import React from "react";
import "./Experience.css";
import { experiences } from "../data/portfolioData";
import { HiBriefcase, HiCalendar, HiLocationMarker } from "react-icons/hi";

function Experience() {
  return (
    <section id="experience" className="experience-section section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Career History</span>
          <h2 className="section-title">Work Experience</h2>
          <p className="section-subtitle">
            Distributed backend systems, real-time event pipelines, and production telemetry in enterprise environments.
          </p>
        </div>

        <div className="timeline-container">
          {experiences.map((exp, index) => (
            <div key={index} className="timeline-item">
              {/* Timeline marker */}
              <div className="timeline-marker">
                <div className="marker-dot">
                  <HiBriefcase size={16} />
                </div>
                {index !== experiences.length - 1 && <div className="marker-line" />}
              </div>

              {/* Timeline card */}
              <div className="timeline-card">
                <div className="card-top">
                  <div>
                    <h3 className="role-title">{exp.role}</h3>
                    <h4 className="company-name">{exp.company}</h4>
                    <span className="domain-tag">{exp.domain}</span>
                  </div>

                  <div className="meta-info">
                    <span className="meta-badge">
                      <HiCalendar size={14} />
                      {exp.period}
                    </span>
                    <span className="meta-badge">
                      <HiLocationMarker size={14} />
                      {exp.location}
                    </span>
                  </div>
                </div>

                <ul className="highlights-list">
                  {exp.highlights.map((point, hIdx) => {
                    // Highlights are maintained without unverified numbers
                    // TODO: add verified metric placeholder
                    return (
                      <li key={hIdx} className="highlight-item">
                        <span className="bullet-point">▸</span>
                        <span className="point-text">{point}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
